<template>
  <div class="">
    <div class="container lnb d_container">
      <div class="contents_wrap no_height">
        <div class="contents list-container">
          <div>nickname 상세정보</div>
          <member-detail-component :member-type="`curatorDetail`"></member-detail-component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MemberDetailComponent from "@/components/member/MemberDetailComponent";

export default {
  name: "CuratorDetail",
  mixins: [],
  components: {
    MemberDetailComponent
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{

    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{

  },
  watch: {

  },
}
</script>

<style scoped>

</style>